import ActionTypes from '../../constants/ActionTypes';

const initialState = {
  data: {
    name: '',
  },
  isSubmitting: false,
  // FAMILY-EXT: ошибку создания проекта показываем в модалке. Раньше она
  // никуда не выводилась — при отказе сервера (403 Not enough rights)
  // модалка просто "ничего не делала".
  error: null,
};

// eslint-disable-next-line default-param-last
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case ActionTypes.PROJECT_CREATE:
      return {
        ...state,
        data: {
          ...state.data,
          ...payload.data,
        },
        isSubmitting: true,
        error: null,
      };
    case ActionTypes.PROJECT_CREATE__SUCCESS:
    // FAMILY-EXT: чтобы при повторном открытии модалки не висела старая ошибка
    case ActionTypes.MODAL_CLOSE:
      return initialState;
    case ActionTypes.PROJECT_CREATE__FAILURE:
      return {
        ...state,
        isSubmitting: false,
        error: payload.error,
      };
    default:
      return state;
  }
};
